export class PreOrdemModel {
    codConcessionaria : number;
    codConsultor : number;
    codIntegracaoConsultor : string;
    cpf : string;
    placa : string;
    marca : string;
    familia : string;
    modelo : string;
    cliente : string;
    telefone : string;
    email : string;
    revisao : string;
    pacote : string;
    codPacote : string;
    codFabrica : string;
    codMOPacote : string;
    tipoOS: string;
    itensFabrica : string;
    itensPacote : string;
    itensAlacarte : string;
    assinatura: string;
    os : string;
    mediames : number;
    data : string;
    hora : string;
    consultor : string;
    tipo : number;
    versao : string;
    retornoIntegracao : string;
    xmlIntegracao : string;
    devicename : string;
    so : string;
    devicemodel : string;
    observacoes : string;
    abertadms : number;
    km: string;
    combustivel: number;
    idagendamento: string;
    hashBase64: string;
    codCheckList: number;
    modeloCheckList: number;
    itens: string;
    valorTotal: string;
    valorParcela: string;
    parcelamento: number;
    oleoNaoRecomendado: boolean;
    lgpd: boolean;
} 



// WEBPACK FOOTER //
// ./src/app/models/PreOrdemModel.ts